import { render, staticRenderFns } from "./StrapiEvenementView.vue?vue&type=template&id=12f514d3"
import script from "./StrapiEvenementView.vue?vue&type=script&lang=js"
export * from "./StrapiEvenementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports